/**
 * @flow
 * Created by neo on 12.07.17.
 */

import * as React from 'react';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';
import { observer } from 'mobx-react';
import 'react-dates/initialize';

import Main from './Main';
import NoMatch from './NoMatch';
import Dashboard from './Dashboard/Screen';
import FlightOffer from './FlightOffer/View';
import FlightOfferBookingScreen from './Booking/FlightOffer';
import FlightBookingScreen from './Booking/Flight';
import VoucherBookingScreen from './Booking/Voucher';
import FlightScreen from './Flight/View';
import BookingViewScreen from './Booking/View';
import FlightRequestScreen from './FlightRequest/View'

@observer
export default class App extends React.Component<void, void> {
  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/" component={Main}>
          <IndexRoute component={Dashboard} />

          <Route path="voucher">
            <IndexRoute component={VoucherBookingScreen} />

            <Route path="offer/:flightOfferId" component={VoucherBookingScreen} />
          </Route>

          <Route path="offer">
            <Route path=":flightOfferId" component={FlightOffer} />
          </Route>
          <Route path="flight">
            <Route path=":flightId" component={FlightScreen} />
          </Route>
          <Route path="request-flight" component={FlightRequestScreen} />
          <Route path="booking">
            <Route path="flightoffer">
              <Route path=":flightOfferId" component={FlightOfferBookingScreen} />
            </Route>
            <Route path="flight">
              <Route path=":flightId" component={FlightBookingScreen} />
            </Route>
            <Route path=":bookingId" component={BookingViewScreen} />
          </Route>
        </Route>
        <Route path="*" component={NoMatch} />
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/index.js